import img1 from './_SMB7824.jpg';
import img2 from './_SMB7856.jpg';
import img3 from './_SMB7895.jpg';
import img4 from './_SMB7965.jpg';
import img5 from './leche_pasteurizada.jpg'

export const productosData = [
  {
    id: "1", 
    nombre: "Queso Gouda Neutro",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "2", 
    nombre: "Queso Gouda Saborizado Aji",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "3", 
    nombre: "Queso Gouda Saborizado Pimienta",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "4", 
    nombre: "Queso Gouda Saborizado Pesto",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "5", 
    nombre: "Queso Gouda Saborizado Verdeo",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "6", 
    nombre: "Queso Gouda Saborizado Oregano",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "7", 
    nombre: "Queso Gouda Saborizado Ahumado",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Horma de 5 kg aprox.",
    //maduracion: "6 meses",
    imagen: img1,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 500 gramos", precio: 0 },
      { id: "media_horma", nombre: "Media horma", peso: "aprox. 1 kilo", precio: 0 },
      { id: "barra", nombre: "Barra", peso: "aprox. 3 kilos", precio: 0 },
      { id: "horma", nombre: "Horma", peso: "aprox. 5 kilos", precio: 0 }
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "8", 
    nombre: "Queso Provoleta",
    descripcion: "Textura semidura y sabor suave. Su maduración le aporta una consistencia firme pero cremosa, ideal para cortar en fetas, cubos o fundir.",
    peso: "Porcion de 350 gramos aprox.",
    //maduracion: "6 meses",
    imagen: img3,
    opciones: [
      { id: "porcion", nombre: "Porción", peso: "aprox. 350 gramos", precio: 0 },
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para ser utilizado en picadas, tablas de quesos o para cocinar.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 180 días)."
  },
  {
    id: "9", 
    nombre: "Leche pasteurizada natural",
    descripcion: "100% natural. Elaborada a partir de leche fresca sin agregados ni conservantes.",
    peso: "3 litros",
    //maduracion: "6 meses",
    imagen: img5,
    opciones: [
      { id: "porcion", nombre: "Botella", peso: "3 litros", precio: 0 },
    ],
    // NUEVO: Datos técnicos para los desplegables
    usosRecomendados: "Ideal para consumo diario, perfecta para tomar sola o para preparar recetas.",
    almacenamiento: "Refrigeración: entre 6° y 10°C (vida útil 3 días)."
  }
];